'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z' });

var ArtTrack = function ArtTrack(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ArtTrack = (0, _pure2.default)(ArtTrack);
ArtTrack.muiName = 'SvgIcon';

exports.default = ArtTrack;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ArtTrack.js
// module id = 2130
// module chunks = 0